"use client" 

import Image from "next/image";
import logo from "../../../public/loghi/logo.png";
import animation from "../../../public/animation/web.json";
import Lottie from "lottie-react";
import SectionTitle from "../shared/SectionTitle";

const MaintenanceSite = () => {
	return (
		<main className="min-h-screen flex flex-col md:flex-row bg-white text-gray-800">
			{/* Left side (logo + testo) */}
			<div className="w-full md:w-1/2 flex flex-col justify-center items-center p-8 md:p-16 text-center md:text-left">
				<Image
					src={logo}
					alt="Logo Santa Marta"
					width={200}
					height={200}
					className="mb-6"
				/>

				<SectionTitle
					title1="Il sito è in manutenzione "
					title2="Tornerà presto online!"
				/>

				<p className="mt-4 max-w-lg text-base text-gray-800 text-center">
					Stiamo lavorando per migliorare la vostra esperienza. Il sito sarà
					nuovamente online a breve, con un’interfaccia più intuitiva e
					coinvolgente. <br /> Vi informiamo inoltre che il numero <strong>+39 338 764 9282</strong> sarà
					temporaneamente disattivato a partire da lunedì 28 luglio. Il servizio
					telefonico sarà nuovamente attivo a partire da giovedì 28 agosto, con
					i consueti orari: dalle 9:00 alle 16:00. Per eventuali urgenze o
					necessità, potete contattarci ai seguenti recapiti alternativi:
				</p>

				<div className="mt-8 w-full max-w-md space-y-6 text-center justify-center">
					<div>
						<div>
							<h3 className="font-semibold text-xl text-[#10b0ff]">Telefono</h3>
							<p className="text-lg">+39 06 962 00 55</p>
						</div>
					</div>

					<div className="flex flex-col">
						<div>
							<h3 className="font-semibold text-xl text-[#10b0ff]">Email</h3>
							<p className="text-lg">santamartavelletri@gmail.com</p>
						</div>
					</div>
				</div>
			</div>

			{/* Right side (immagine illustrata) */}
			<div className="w-full md:w-1/2 h-64 md:h-auto flex items-center justify-center p-6">
				<Lottie
					animationData={animation}
					loop
					autoplay
					className="w-full max-w-xl h-auto"
				/>
			</div>
		</main>
	);
};

export default MaintenanceSite;
